"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = RedemptionForm;
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _core = require("@linaria/core");
var _spinner = _interopRequireDefault(require("@ux/spinner"));
var _index = _interopRequireDefault(require("../../../elements/other/actions/index"));
var _intents = _interopRequireDefault(require("@site/pattern-library-utils/intents"));
const errorTextStyles = "pl-e1c4u4fj";
const inputBarStyles = "pl-i1wrg4zp";
function RedemptionForm({
  id,
  isLoading,
  submitText,
  redemptionPlaceHolderText,
  errorText,
  handleOnSearch,
  enteredCode,
  setEnteredCode
}) {
  const inputBar = {
    id: id,
    disabled: isLoading,
    clearable: true,
    value: enteredCode,
    placeholder: redemptionPlaceHolderText,
    ariaInputLabel: redemptionPlaceHolderText,
    ariaButtonLabel: submitText,
    handleOnChange: setEnteredCode,
    button: {
      text: submitText,
      disabled: isLoading
    }
  };
  return /*#__PURE__*/_react.default.createElement("form", {
    "data-cy": "redemption-search-form",
    className: `redemption-input-container ${inputBarStyles}`,
    id: `redemption-form-${id}`,
    onSubmit: e => {
      e.preventDefault();
      const cleanedCode = enteredCode?.trim();
      handleOnSearch(cleanedCode);
    },
    role: "search"
  }, /*#__PURE__*/_react.default.createElement(_index.default, {
    actionsLayout: "input-bar",
    ctas: [inputBar]
  }), isLoading && /*#__PURE__*/_react.default.createElement("div", {
    className: "text-center"
  }, /*#__PURE__*/_react.default.createElement(_spinner.default, {
    inline: true,
    size: "md",
    shade: "primary"
  })), errorText && /*#__PURE__*/_react.default.createElement("div", {
    className: `text-center ${errorTextStyles}`,
    "data-cy": "input-error"
  }, errorText));
}
RedemptionForm.propTypes = {
  id: _propTypes.default.string,
  isLoading: _propTypes.default.bool,
  submitText: _propTypes.default.string,
  redemptionPlaceHolderText: _propTypes.default.string,
  errorText: _propTypes.default.string,
  handleOnSearch: _propTypes.default.func,
  enteredCode: _propTypes.default.string,
  setEnteredCode: _propTypes.default.func
};